import React from 'react';
import axios from 'axios';
import {useDispatch} from 'react-redux';

import {authExpiredError} from '../actions/login';

import config from 'config';

const defaultOptions = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain',
  },
  timeout: config.requestTimeout,
};

export function fetch(url, options = {}) {
  return axios(Object.assign({url}, defaultOptions, options));
}

const EXPIRED = 'EXPIRED';
const PENDING = 'PENDING';
const IDLE = 'IDLE';
const SUCCESS = 'SUCCESS';
const REJECT = 'REJECT';

export default function useFetch(endpoint, {redirectOnUnauth = true} = {}) {
  const dispatch = useDispatch();
  const [state, setState] = React.useState({
    fetchStatus: IDLE,
    data: null,
    error: null,
  });

  React.useEffect(() => {
    setState({data: null, error: null, fetchStatus: PENDING});

    fetch(`${config.api}/${endpoint}`, defaultOptions)
      .then(({data}) => {
        setState({fetchStatus: SUCCESS, data, error: null});
      })
      .catch(error => {
        const {response, message} = error;
        if (response) {
          if (redirectOnUnauth && (response.status === 401 || response.status === 403)) {
            dispatch(authExpiredError('you must login first'));
            return;
          }

          setState({fetchStatus: REJECT, data: null, error: message});
        }
      });
  }, []);

  return state;
}
